import { FormattedMessage } from "react-intl";

import type { LabelOrTranslationID } from "@citrine/lang/utils";

export type ItemProps<Value extends string | undefined = string> = {
  value: Value;
  disabled?: boolean;
} & LabelOrTranslationID;

/**
 * This <Item/> component is used to render the individual items within <Tabs/>
 * or <Select/> components. This provides a consistent API, especially if using
 * the "select" variant of the <Tabs/> component.
 */
export function Item<Value extends string = string>({
  label,
  translationId,
  value,
}: ItemProps<Value>) {
  return translationId ? (
    <FormattedMessage id={translationId} />
  ) : (
    <>{label ?? value}</>
  );
}
